module.exports = __webpack_public_path__ + "static/img/5071_phase_function_Paper_PointsHejduk_Prediction.cf4d5fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5071_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RxB6
// module chunks = 0